import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Services() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation<HTMLDivElement>();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.1 });

  const services = [
    {
      icon: 'ri-search-line',
      title: 'Recrutamento e Seleção',
      description: 'Processos seletivos completos e personalizados para identificar os candidatos ideais para cada posição. Utilizamos técnicas modernas de avaliação e mapeamento de competências para garantir o match perfeito entre profissional e empresa.',
      image: 'https://readdy.ai/api/search-image?query=professional%20job%20interview%20recruitment%20process%20with%20hr%20manager%20and%20candidate%20in%20modern%20office%20clean%20simple%20background%20corporate%20hiring%20atmosphere%20professional%20setting&width=400&height=300&seq=service1&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: 'Consultoria em RH',
      description: 'Assessoria estratégica para otimizar a gestão de pessoas na sua empresa. Desenvolvemos políticas de RH, estruturamos planos de cargos e salários, e implementamos sistemas de avaliação de desempenho alinhados aos objetivos organizacionais.',
      image: 'https://readdy.ai/api/search-image?query=business%20consulting%20meeting%20with%20hr%20consultants%20and%20executives%20discussing%20strategy%20modern%20office%20environment%20clean%20professional%20background%20corporate%20consulting%20scene&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Treinamento e Desenvolvimento',
      description: 'Programas de capacitação customizados para desenvolver competências técnicas e comportamentais. Oferecemos workshops, cursos e programas de desenvolvimento de liderança que impulsionam o crescimento profissional e organizacional.',
      image: 'https://readdy.ai/api/search-image?query=corporate%20training%20workshop%20with%20professionals%20learning%20and%20developing%20skills%20in%20modern%20training%20room%20clean%20bright%20environment%20business%20education%20setting&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Headhunting Executivo',
      description: 'Busca e seleção de executivos e profissionais de alta performance para posições estratégicas. Atuamos com discrição e eficiência na identificação de talentos diferenciados no mercado, garantindo confidencialidade total no processo.',
      image: 'https://readdy.ai/api/search-image?query=executive%20business%20professional%20in%20modern%20corporate%20office%20leadership%20portrait%20clean%20minimalist%20background%20professional%20corporate%20atmosphere%20high%20level%20executive&width=400&height=300&seq=service4&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Avaliação de Desempenho',
      description: 'Implementação de sistemas de avaliação que mensuram resultados e identificam oportunidades de melhoria. Utilizamos metodologias como avaliação 360 graus, OKRs e KPIs para promover o desenvolvimento contínuo das equipes.',
      image: 'https://readdy.ai/api/search-image?query=business%20performance%20analysis%20with%20professionals%20reviewing%20charts%20and%20metrics%20modern%20office%20workspace%20clean%20professional%20background%20corporate%20analytics%20environment&width=400&height=300&seq=service5&orientation=landscape'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Terceirização de RH',
      description: 'Gestão completa do departamento de Recursos Humanos da sua empresa. Cuidamos de toda a rotina de RH, incluindo folha de pagamento, benefícios, admissões, demissões e compliance trabalhista, permitindo que você foque no core business.',
      image: 'https://readdy.ai/api/search-image?query=human%20resources%20management%20team%20working%20with%20documents%20and%20systems%20in%20modern%20office%20clean%20organized%20workspace%20professional%20hr%20department%20atmosphere&width=400&height=300&seq=service6&orientation=landscape'
    }
  ];

  return (
    <section id="servicos" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="w-full px-6">
        <div className="max-w-[90%] mx-auto">
          <div 
            ref={titleRef}
            className={`text-center mb-16 transition-all duration-1000 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}`}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nossos <span className="text-[#D4AF37]">Serviços</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Oferecemos soluções completas e personalizadas em Recursos Humanos para impulsionar o crescimento da sua empresa através da gestão estratégica de pessoas
            </p>
          </div>

          <div ref={cardsRef} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group ${cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
                style={{ transitionDelay: cardsVisible ? `${index * 100}ms` : '0ms' }}
              >
                <div className="w-full h-48 overflow-hidden">
                  <img 
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="w-14 h-14 bg-[#D4AF37] rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#B8941F] transition-colors">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
